/** "B · 87%" when the school scale produced a letter, otherwise "87%". */
export function gradeText(grade?: { percent?: number | null; letter?: string | null } | null) {
  if (grade?.percent == null) return "";
  return grade.letter ? `${grade.letter} · ${grade.percent}%` : `${grade.percent}%`;
}
